module.exports = __webpack_public_path__ + "static/media/4.5e3f84f5.png";